// @ts-strict-ignore
import { Button, List, Tooltip, mediaQuery } from "@hubble/web";

import styled, { keyframes } from "styled-components";
import { Colors } from "themes/color-palette";

export const CustomContainer = styled.div`
  @media ${mediaQuery.tabletSmUp} {
    margin-top: 30px;
  }

  @media ${mediaQuery.desktopLgUp} {
    > div > div > div > div {
      padding-left: 80px !important;
      padding-right: 80px !important;
    }
  }

  @media ${mediaQuery.tabletSmDown} {
    margin: 0px;

    > div > div > div > div {
      padding-top: 0px !important;
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
  @media ${mediaQuery.mobileXsDown} {
    margin: -16px 0px 0px 0px;

    > div > div > div > div {
      padding-top: 0px !important;
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
`;

export const CoinPriceChartContainer = styled.div`
  width: 100%;
  & > div:first-child {
    border-radius: 20px;
    width: 100%;
    left: 0px;
    @media ${mediaQuery.mobileXsDown} {
      left: -16px;
      border-radius: 0px;
      width: calc(100% + 32px);
      padding: 1rem;
      padding-top: 4rem;
    }
    @media ${mediaQuery.tabletSmDown} {
      border-radius: 0px;
    }
  }
`;

export const CoinMetaList = styled(List)`
  flex: 1;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${Colors.gray[50]};
  height: fit-content;
  margin: 0;
  min-width: 300px;

  &:first-child {
    @media ${mediaQuery.mobileXsDown} {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &:nth-child(2) {
    @media ${mediaQuery.mobileXsDown} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }

  hr {
    border: none;
    border-bottom: 1px solid ${Colors.gray[100]};
  }
`;

export const ChartAlertButton = styled(Button.Secondary)`
  &::after {
    opacity: 0;
    transition: opacity 0s ease-in-out 0.5s;
  }
  ${({ isTooltipVisible }) =>
    isTooltipVisible &&
    `
position: relative;
overflow: visible;
&::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  border: none;
  background: ${Colors.blue[500]};
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  transition: opacity 0s ease-in-out 0.5s;
  opacity: 1;
}
`}
`;

export const ChartAlertButtonTooltip = styled(Tooltip).attrs({
  placement: "bottom",
  overlayInnerStyle: {
    backgroundColor: Colors.blue[500]
  },
  align: { offset: [-50, 8] },
  mouseEnterDelay: 0
})`` as typeof Tooltip;

export const ChartSocialShareButtonWrapper = styled.div``;

const pulse = keyframes`
  0% {
    background-color: ${Colors.gray[500]};
  }
  50% {
    background-color: ${Colors.green[500]};
  }
  100% {
    background-color: ${Colors.gray[500]};
  }
`;

export const PulsingDot = styled.div<{ active: boolean }>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 6px;

  background-color: ${Colors.gray[500]};
  animation: ${pulse} 2s infinite;
  animation-play-state: ${({ active }) => (active ? "running" : "paused")};
`;
